<template>
  <div class="bossbox">
    <div class="tablelist">
      <el-table ref="filterTable" :data="tableData" style="width: 100%;margin-top: 45px;" :row-class-name="tableRowClassName" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(25, 26, 31, 0.8)">
        <el-table-column prop="created_at" label="头像" width="350px" align="center" column-key="date">
          <template slot-scope="scope">
            <!-- {{scope.row.realname}} -->
            <img v-if="scope.row.head_img" :src="scope.row.head_img" style="width: 50px;height: 50px;" alt="">
            <img v-else src="../../../static/img2/tx.png" style="width: 50px;height: 50px;" alt="">
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="realname"></el-table-column>
        <el-table-column label="操作" width="150px" align="center">
          <template slot-scope="scope">
            <a size="mini" style="color:#C0C4CC;cursor:pointer;" @click="toogleExpand(scope.row, scope.$index)">提问</a>
          </template>
        </el-table-column>
        <!-- <el-table-column type="expand" width="0">
          <template slot-scope="props">
            <div class="box-body">
              <div class="box-body-rigth">
                <div class="box-body-rigth-message" ref="scrollWrapper">
                  <div class="box-body-rigth-li" v-for="iten in 5">
                    <img src="../../assets/img/1.png" alt="">
                    <div>
                      <span>
                        你好
                      </span>
                    </div>
                  </div>
                  <div class="box-body-rigth-lileft" v-for="iten in 10">
                    <img src="../../assets/img/1.png" alt="">
                    <div>
                      <span>
                        你好
                      </span>
                    </div>
                  </div>
                </div>
                <div class="box-body-rigth-bottom">
                  <div class="box-body-rigth-bottom-text">
                    <div class="bottom-text-input">
                      <el-input type="textarea" v-model="desc"></el-input>
                    </div>
                    <el-button type="primary" class="bottom-text-btn" plain>确定</el-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <teachmessage :dialogVisiblemess="dialogVisiblemess" @lcclick="lcclick" :row="row"/>
  </div>
</template>

<script>
import teachmessage from '../User/teachmessage.vue'
export default {
  components: { teachmessage },
  name: 'Practices',
  data() {
    return {
      loading: true,
      tableData: [],
      loading: true,
      desc: '',
      dialogVisiblemess:false,
      row:{}
    }
  },

  methods: {
    // 默认滚动到底部
    scrollToBottom() {
      setTimeout(() => {
        const wrapper = this.$refs.scrollWrapper
        wrapper.scrollTop = wrapper.scrollHeight
      }, 100)
    },
    // 点击了回复
    toogleExpand(row) {
      this.row=row
      this.dialogVisiblemess=true

      // const $table = this.$refs.filterTable
      // this.tableData.map((item) => {
      //   if (row.ID != item.ID) {
      //     $table.toggleRowExpansion(item, false)
      //   }
      // })
      // $table.toggleRowExpansion(row)
      // this.scrollToBottom()
    },
    // 关闭弹框
    lcclick(){
      this.dialogVisiblemess=false
    },
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex%2)===0) {
        return 'warning-row'
      } else {
        return 'success-row'
      }
      return ''
    },
    getScore() {
      this.$http.getteacher().then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.tableData = res.data
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  mounted() {
    this.getScore()
  },
  created() {},
}
</script>

<style lang="less" >
@import '../../../static/fonts/stylemain/style.less';
.el-table__expand-icon {
  display: none;
}
/deep/ .el-table tbody tr:hover > td {
  background-color: #f5f5f5 !important //修改成自己想要的颜色即可
;
}
.bossbox{
  background-color: @bg3;
}


@media screen and (max-width: 768px) {
  .tablelist {
    width: 92%;
    margin: auto;
    overflow: hidden;
    display: none;
    background: #24252c;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }
  .tablelistt {
    width: 92%;
    height: 100%;
    margin: auto;
    overflow: hidden;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }

  .bottomtion111 {
    height: 65px;
    width: 100%;
    background-color: #2f3037;
    //  margin-top: 20px;
    position: absolute;
    bottom: 0;
    // z-index: 1000;
    display: flex;
    justify-content: center;
  }
  .el-pagination {
    margin: auto;
  }
}
@media screen and (min-width: 768px) {
  .tablelist {
    width: 1216px;
    margin: auto;
    background: #24252c;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }
  .tablelistt {
    width: 92%;
    height: 240rem;
    margin: auto;
    display: none;
    overflow: hidden;
    .el-table .warning-row {
      background: #24252c;
      color: rgb(203, 200, 200);
    }

    .el-table .success-row {
      background: #2a2b32;
      color: rgb(203, 200, 200);
    }
  }

  .bottomtion111 {
    height: 65px;
    width: 100%;
    background-color: #2f3037;
    //  margin-top: 20px;
    position: absolute;
    bottom: 0;
    // z-index: 1000;
    display: flex;
    justify-content: center;
  }
  .el-pagination {
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/teacherlist.vue